import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f15f03d")

_pushScopeId("data-v-6f15f03d")
const _hoisted_1 = { class: "bg-ff content" }
const _hoisted_2 = { class: "flex alignC mar-b-30 mar-l-30" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_4 = { class: "padding-30" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "width-211" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "flex flexC alignC mar-t-22" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "提交", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("返回")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_editList = _resolveComponent("editList")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode("div", null, [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.formRules,
          inline: true,
          "label-width": "120px",
          class: "width-900"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_el_form_item, {
                label: "单据日期",
                prop: "date"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "width-211",
                    modelValue: _ctx.form.date,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.date = $event)),
                    type: "date",
                    "value-format": "x",
                    placeholder: "选择日期"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "采购员",
                prop: "employee_id"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.employee_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.employee_id = $event)),
                    placeholder: "请选择",
                    class: "width-211"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PurchaseManList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item.nickname,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", null, [
              _createVNode(_component_el_form_item, {
                label: "供应商",
                prop: "supplier_id"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.form.supplier), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "采购金额" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    class: "width-211",
                    modelValue: _ctx.form.total_price,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.total_price = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", null, [
              _createVNode(_component_el_form_item, { label: "备注" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    style: {"width":"600px"},
                    modelValue: _ctx.form.purchase_desc,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.purchase_desc = $event)),
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createVNode(_component_editList, {
        partsData: _ctx.form.parts,
        show_add: false
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "配件名称",
            width: "150"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_7, _toDisplayString(scope.row.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "规格",
            width: "100"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_8, _toDisplayString(scope.row.specification), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "配件分类",
            width: "100"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_9, _toDisplayString(scope.row.mountings_type_p_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "品牌",
            width: "100"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_10, _toDisplayString(scope.row.mountings_brand_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            width: "100"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_11, _toDisplayString(scope.row.mountings_unit_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "采购单价",
            width: "125"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_12, _toDisplayString(scope.row.unit_price), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "采购数量",
            width: "125"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_13, _toDisplayString(scope.row.number), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "已退",
            width: "125"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_14, _toDisplayString(scope.row.retired_number), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "可退",
            width: "125"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_15, _toDisplayString(scope.row.refundable_number), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "退货数量",
            width: "125"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_input, {
                modelValue: scope.row.return_number,
                "onUpdate:modelValue": ($event: any) => (scope.row.return_number = $event),
                type: "text",
                class: "mar-l-16",
                style: {"width":"80px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["partsData"]),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_el_button, {
          class: "bg-red",
          onClick: _ctx._onsubmit
        }, {
          default: _withId(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withId(() => [
            _hoisted_18
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_directive_loading, _ctx.is_load]
    ])
  ]))
})